// ============================================================================
// قاموس سترونج - الترجمات العربية
// IDs قصيرة: m=معنى, d=تعريف, u=استخدام, e=اشتقاق
// 153 إدخال كامل لجميع أرقام سترونج في المشروع
// ============================================================================

export const strongTranslationsAR = {
  "G11": {
    m: "إبراهيم",
    d: "البطريرك إبراهيم، أب المؤمنين.",
    u: "استُخدمت 73 مرة في العهد الجديد. نموذج الإيمان.",
    e: "من العبرية אַבְרָהָם (إبراهام) = أب لجمهور"
  },
  "G25": {
    m: "أن يحب بمحبة إلهية وغير مشروطة",
    d: "أن يحب بمحبة غير أنانية وتضحية وإلهية. إنها محبة الله للبشرية والمحبة التي يجب أن نحملها لبعضنا البعض.",
    u: "استُخدمت 143 مرة في العهد الجديد. تصف المحبة الإلهية والكاملة وغير المشروطة.",
    e: "من ἄγω (آغو) = قاد، وجّه نحو الخير"
  },
  "G26": {
    m: "محبة إلهية، محبة",
    d: "محبة الله الكاملة؛ محبة أخوية، عاطفة، حسن نية، محبة. المحبة التي توحّد الله والإنسان، والإنسان بقريبه.",
    u: "استُخدمت 116 مرة في العهد الجديد. الكلمة المركزية للمسيحية لوصف المحبة الإلهية.",
    e: "مشتق من ἀγαπάω (أغاباو)"
  },
  "G27": {
    m: "محبوب، عزيز",
    d: "محبوب، مكرّم؛ محبوب من الله أو الناس.",
    u: "استُخدمت 61 مرة في العهد الجديد. الابن الحبيب لله.",
    e: "من ἀγαπάω (أغاباو) = أحب"
  },
  "G32": {
    m: "ملاك، رسول",
    d: "رسول؛ ملاك سماوي في خدمة الله.",
    u: "استُخدمت 175 مرة في العهد الجديد. ملائكة الله.",
    e: "من ἀγγέλλω (أنجيلو) = أعلن"
  },
  "G36": {
    m: "منحط الأصل، وضيع",
    d: "بلا نبل، من أصل وضيع؛ محتقر.",
    u: "استُخدمت مرة واحدة في العهد الجديد (1 كورنثوس 1:28).",
    e: "من ἀ- (سلبي) + γένος (جينوس) = ولادة"
  },
  "G93": {
    m: "ظلم، إثم",
    d: "انتهاك للحق، ظلم؛ شر، إثم أخلاقي.",
    u: "استُخدمت 25 مرة في العهد الجديد. عكس δικαιοσύνη (عدل).",
    e: "من ἀ- (سلبي) + δίκη (ديكي) = عدل"
  },
  "G154": {
    m: "يطلب، يسأل، يتوسل",
    d: "يطلب، يسأل شيئاً، يتوسل، يلتمس. طلب متواضع ومحترم.",
    u: "استُخدم 70 مرة في العهد الجديد. طلب موجه إلى الله أو الناس.",
    e: "من αἰτέω (أيتيو) جذر أساسي؛ يطلب"
  },
  "G166": {
    m: "أبدي، دائم",
    d: "بلا بداية ولا نهاية، موجود دائماً؛ في العهد الجديد، غالباً ما يرتبط بالحياة الأبدية في الله.",
    u: "استُخدمت 71 مرة في العهد الجديد. تصف غالباً الحياة الأبدية وملكوت الله.",
    e: "من αἰών (أيون) = عصر، زمن، أبدية"
  },
  "G225": {
    m: "حق، حقيقة",
    d: "ما هو حق في الأمور المتعلقة بالله وواجبات الإنسان؛ الحق الإلهي المعلن.",
    u: "استُخدمت 109 مرات في العهد الجديد. مفهوم مركزي في تعليم يسوع.",
    e: "من ἀληθής (أليثيس) = حق، صادق"
  },
  "G281": {
    m: "آمين، حقاً",
    d: "صيغة تأكيد: فليكن كذلك، حقاً، بالتأكيد.",
    u: "استُخدمت 129 مرة في العهد الجديد. يسوع يقول 'الحق الحق'.",
    e: "من العبرية אָמֵן (آمين) = ثابت، أمين"
  },
  "G444": {
    m: "إنسان، بشر",
    d: "كائن بشري، رجل أو امرأة؛ البشرية بشكل عام.",
    u: "استُخدمت 550 مرة في العهد الجديد. الإنسان مخلوق على صورة الله.",
    e: "من ἀνήρ (أنير) = رجل و ὤψ (أوبس) = وجه"
  },
  "G622": {
    m: "أضاع، دمّر، هلك",
    d: "دمّر تماماً؛ أضاع، هلك؛ خُرّب.",
    u: "استُخدمت 90 مرة في العهد الجديد. يُخلّص ما كان هالكاً.",
    e: "من ἀπό (أبو) = من + ὄλλυμι (أولومي) = دمّر"
  },
  "G649": {
    m: "أرسل، فوّض",
    d: "أرسل بمهمة؛ فوّض كسفير.",
    u: "استُخدمت 132 مرة في العهد الجديد. الآب يرسل الابن.",
    e: "من ἀπό (أبو) = من + στέλλω (ستيلو) = أرسل"
  },
  "G721": {
    m: "حمَل",
    d: "حمَل صغير؛ يشير إلى يسوع المسيح كحمَل الله.",
    u: "استُخدمت 30 مرة في العهد الجديد، خاصة في الرؤيا.",
    e: "تصغير من ἀρήν (أرين) = حمَل"
  },
  "G730": {
    m: "ذكر، مذكر",
    d: "من الجنس الذكري، ذكر.",
    u: "استُخدمت 9 مرات في العهد الجديد. الله خلق الإنسان ذكراً وأنثى.",
    e: "جذر أساسي"
  },
  "G740": {
    m: "خبز",
    d: "خبز، طعام؛ خبز الحياة = المسيح.",
    u: "استُخدمت 97 مرة في العهد الجديد. يسوع خبز الحياة.",
    e: "من ἄρω (آرو) = رفع، حمل"
  },
  "G746": {
    m: "بداية، مبدأ",
    d: "البداية، الأصل، المبدأ الأول. في يوحنا 1:1-2، يشير إلى البداية الأزلية حيث كانت الكلمة (اللوغوس) موجودة بالفعل.",
    u: "استُخدمت 55 مرة في العهد الجديد. الكلمة الأساسية في يوحنا 1:1 'في البدء كان الكلمة'.",
    e: "كلمة أساسية؛ بداية، أصل أول"
  },
  "G772": {
    m: "ضعيف، مريض",
    d: "بلا قوة، ضعيف؛ مريض، عليل؛ ضعيف روحياً.",
    u: "استُخدمت 25 مرة في العهد الجديد. الله يختار ضعفاء العالم.",
    e: "من ἀ- (سلبي) + σθένος (سثينوس) = قوة"
  },
  "G907": {
    m: "عمّد، غمر",
    d: "غمر في الماء؛ عمّد للتطهير أو التدشين.",
    u: "استُخدمت 77 مرة في العهد الجديد. العماد المسيحي.",
    e: "من βάπτω (بابتو) = غطس، غمر"
  },
  "G1080": {
    m: "ولّد، أنجب",
    d: "ولّد، أنجب؛ وُلد ثانية روحياً.",
    u: "استُخدمت 97 مرة في العهد الجديد. وُلد من الله، وُلد ثانية.",
    e: "جذر أساسي"
  },
  "G1096": {
    m: "يصبح، يحدث، يكون",
    d: "يصبح، يأتي إلى الوجود، يحدث، يقع، يجري.",
    u: "استُخدمت 678 مرة في العهد الجديد. 'كل شيء به كان' (يوحنا 1:3).",
    e: "من γίνομαι (غينومي) = يصبح"
  },
  "G1097": {
    m: "عرف، علم، فهم",
    d: "أن يعرف بالخبرة الشخصية؛ فهم، أدرك، كان واعياً.",
    u: "استُخدمت 222 مرة في العهد الجديد. معرفة تجريبية، ليست فكرية فقط.",
    e: "جذر هندي أوروبي *gen- = ولّد، عرف"
  },
  "G1100": {
    m: "لسان، لغة",
    d: "عضو الكلام؛ لغة، لهجة؛ موهبة الألسنة.",
    u: "استُخدمت 50 مرة في العهد الجديد. موهبة الألسنة.",
    e: "جذر أساسي"
  },
  "G1166": {
    m: "أظهر، برهن",
    d: "عرض للعيان، أظهر؛ برهن، أثبت.",
    u: "استُخدمت 33 مرة في العهد الجديد. الله يُظهر مجده.",
    e: "جذر أساسي"
  },
  "G1208": {
    m: "ثانٍ، ثاني",
    d: "الثاني في سلسلة أو ترتيب.",
    u: "استُخدمت 44 مرة في العهد الجديد. الوصية الثانية.",
    e: "من δύο (دوو) = اثنان"
  },
  "G1271": {
    m: "ذكاء، فكر",
    d: "ملكة التفكير والسماع والفهم؛ العقل، الإدراك.",
    u: "استُخدمت 12 مرة في العهد الجديد. العقل المجدد بالمسيح.",
    e: "من διά (ديا) = عبر + νοῦς (نوس) = عقل"
  },
  "G1320": {
    m: "معلم، أستاذ، مُدرِّس",
    d: "معلم، مُدرِّس؛ من يُعلِّم الحقائق الدينية.",
    u: "استُخدمت 59 مرة في العهد الجديد. 'رابي، نعلم أنك معلم قد أتيت من الله' (يوحنا 3:2).",
    e: "من διδάσκω (ديداسكو) = يُعلِّم"
  },
  "G1325": {
    m: "أعطى، منح",
    d: "أعطى شيئاً لشخص؛ منح، سمح؛ سلّم.",
    u: "استُخدمت 415 مرة في العهد الجديد. الله يعطي بسخاء.",
    e: "جذر أساسي"
  },
  "G1372": {
    m: "عطش، اشتاق بشدة",
    d: "عانى من العطش؛ اشتاق بشدة، تاق إلى.",
    u: "استُخدمت 16 مرة في العهد الجديد. العطش الروحي إلى الله.",
    e: "من δίψα (ديبسا) = عطش"
  },
  "G1401": {
    m: "عبد، خادم",
    d: "عبد، خادم؛ خادم الله بإرادته.",
    u: "استُخدمت 124 مرة في العهد الجديد. عبيد المسيح.",
    e: "من δέω (ديو) = ربط"
  },
  "G1411": {
    m: "قوة، قدرة، معجزة",
    d: "قوة، سلطة، قدرة؛ عمل قوة، معجزة.",
    u: "استُخدمت 120 مرة في العهد الجديد. قوة الله، الروح القدس.",
    e: "من δύναμαι (دوناماي) = كان قادراً"
  },
  "G1417": {
    m: "اثنان",
    d: "العدد اثنان؛ زوج.",
    u: "استُخدمت 135 مرة في العهد الجديد. شاهدان أو ثلاثة.",
    e: "جذر أساسي"
  },
  "G1473": {
    m: "أنا",
    d: "ضمير شخصي للمتكلم المفرد.",
    u: "استُخدمت 2567 مرة في العهد الجديد. متكرر جداً.",
    e: "ضمير أساسي"
  },
  "G1484": {
    m: "أمة، شعب، وثنيون",
    d: "شعب، أمة؛ الأمم الوثنية (غير اليهود).",
    u: "استُخدمت 162 مرة في العهد الجديد. الإنجيل لكل الأمم.",
    e: "جذر أساسي"
  },
  "G1492": {
    m: "يعرف، يرى، يفهم",
    d: "يعرف بالإدراك، يرى، يفهم، يدرك. المعرفة المكتسبة من خلال التجربة أو الوحي.",
    u: "استُخدمت 666 مرة في العهد الجديد. فعل المعرفة الأساسي في إنجيل يوحنا.",
    e: "الصيغة التامة لـ εἴδω (إيدو)؛ يرى، يعرف"
  },
  "G1510": {
    m: "كان، وُجد",
    d: "فعل الكينونة بكل معانيه؛ وُجد، بقي، حدث.",
    u: "الفعل الأكثر استخداماً في العهد الجديد (2460+ مرة).",
    e: "جذر أساسي"
  },
  "G1515": {
    m: "سلام",
    d: "حالة من السكينة؛ سلام مع الله؛ انسجام بين الأشخاص.",
    u: "استُخدمت 92 مرة في العهد الجديد. سلام المسيح.",
    e: "من εἴρω (إيرو) = وصل، ربط"
  },
  "G1520": {
    m: "واحد، أحد",
    d: "واحد فقط؛ أحد، فقط؛ معين.",
    u: "استُخدمت 344 مرة في العهد الجديد. وحدانية الله، الكنيسة الموحدة.",
    e: "جذر أساسي"
  },
  "G1586": {
    m: "اختار، انتخب",
    d: "اختار لنفسه، انتقى؛ انتخب بنعمة إلهية.",
    u: "استُخدمت 21 مرة في العهد الجديد. الله ينتخب أبناءه.",
    e: "من ἐκ (إك) = من + λέγω (ليغو) = اختار"
  },
  "G1658": {
    m: "حر، معتق",
    d: "حر، غير عبد؛ محرّر من عبودية الخطية.",
    u: "استُخدمت 23 مرة في العهد الجديد. محررون في المسيح.",
    e: "ربما من ἔρχομαι (إرخوماي) = جاء"
  },
  "G1672": {
    m: "يوناني، أممي",
    d: "يوناني بالولادة أو اللغة؛ غير يهودي.",
    u: "استُخدمت 25 مرة في العهد الجديد. لا يهودي ولا يوناني في المسيح.",
    e: "من Ἑλλάς (هيلاس) = اليونان"
  },
  "G1680": {
    m: "رجاء، توقع واثق",
    d: "انتظار الأشياء الجيدة، رجاء مؤسس على الله؛ ثقة في المستقبل مبنية على الوعود الإلهية.",
    u: "استُخدمت 54 مرة في العهد الجديد. واحدة من الفضائل الثلاث اللاهوتية مع الإيمان والمحبة.",
    e: "من ἔλπω (إلبو) = انتظر، رجا"
  },
  "G1743": {
    m: "قوّى، جعل قوياً",
    d: "جعل قوياً، قوّى؛ أعطى قوة.",
    u: "استُخدمت 8 مرات في العهد الجديد. الله يقوّي المؤمنين.",
    e: "من ἐν (إن) = في + δυναμόω (دوناموو) = جعل قوياً"
  },
  "G1746": {
    m: "لبس، ارتدى",
    d: "ارتدى ثوباً؛ لبس صفة أو قوة.",
    u: "استُخدمت 27 مرة في العهد الجديد. البس المسيح، البس سلاح الله.",
    e: "من ἐν (إن) = في + δύω (دوو) = دخل، لبس"
  },
  "G1785": {
    m: "وصية، أمر",
    d: "أمر، وصية، حكم؛ خصوصاً وصية إلهية.",
    u: "استُخدمت 67 مرة في العهد الجديد. وصايا الله والمسيح.",
    e: "من ἐντέλλομαι (إنتيلومي) = أمر"
  },
  "G1848": {
    m: "احتقر، عامل باحتقار",
    d: "اعتبر كلا شيء، احتقر؛ عامل بازدراء.",
    u: "استُخدمت 11 مرة في العهد الجديد. العالم يحتقر ما يختاره الله.",
    e: "من ἐξ (إكس) = من + οὐθείς (أوثيس) = لا أحد"
  },
  "G2041": {
    m: "عمل، شغل، فعل",
    d: "عمل، كدح؛ فعل، عمل؛ عمل منجز.",
    u: "استُخدمت 169 مرة في العهد الجديد. أعمال الله، الأعمال الصالحة.",
    e: "من ἔργω (إرغو) = عمل"
  },
  "G2048": {
    m: "صحراء، موحش",
    d: "مكان مقفر، برية؛ موحش، مهجور.",
    u: "استُخدمت 48 مرة في العهد الجديد. الأربعون يوماً ليسوع في الصحراء.",
    e: "من ἔρημος (إريموس) = مهجور"
  },
  "G2065": {
    m: "يسأل، يستجوب، يستفسر",
    d: "يسأل، يستجوب، يستفسر للحصول على معلومات. تحقيق أو استقصاء.",
    u: "استُخدم 63 مرة في العهد الجديد. السؤال للحصول على أجوبة.",
    e: "جذر غير مؤكد؛ يسأل، يستجوب"
  },
  "G2189": {
    m: "عداوة، خصومة",
    d: "كراهية، عداوة، خصومة.",
    u: "استُخدمت 6 مرات في العهد الجديد. العداوة مع الله أُزيلت.",
    e: "من ἐχθρός (إخثروس) = عدو"
  },
  "G2205": {
    m: "غيرة، حسد",
    d: "حماس عاطفي؛ يمكن أن يكون إيجابياً (غيرة على الله) أو سلبياً (حسد).",
    u: "استُخدمت 16 مرة في العهد الجديد. يمكن أن يكون فاضلاً أو رذيلة حسب السياق.",
    e: "من ζέω (زيو) = غلى، كان متحمساً"
  },
  "G2222": {
    m: "حياة",
    d: "حياة جسدية أو روحية؛ الحياة الأبدية في الله.",
    u: "استُخدمت 135 مرة في العهد الجديد. يسوع هو الحياة.",
    e: "من ζάω (زاو) = عاش"
  },
  "G2258": {
    m: "كان، هو كان",
    d: "كان، هو كان، هي كانت. صيغة ماضي ناقص لفعل الكون (εἰμί). يعبر عن حالة أو وجود في الماضي.",
    u: "استُخدم 267 مرة في العهد الجديد. أساسي في يوحنا 1:1 'في البدء كان الكلمة'.",
    e: "ماضي ناقص من εἰμί (إيمي) = كان؛ كان"
  },
  "G2296": {
    m: "يتعجب، يندهش، يُعجب",
    d: "يتعجب، يندهش، يكون مندهشاً، يُعجب. رد فعل الدهشة أمام شيء استثنائي.",
    u: "استُخدم 43 مرة في العهد الجديد. رد فعل متكرر على معجزات وتعاليم يسوع.",
    e: "من θαῦμα (ثاوما) = عجيبة؛ يتعجب"
  },
  "G2316": {
    m: "الله، إله",
    d: "الله الحقيقي الوحيد، الكائن الأسمى والأبدي. في العهد الجديد، يشير إلى الله الآب، أو يسوع المسيح الابن، أو الروح القدس - الثالوث الأقدس.",
    u: "استُخدمت 1343 مرة في العهد الجديد. الكلمة الأساسية للإشارة إلى الإله الحقيقي الواحد في وحدة الثالوث.",
    e: "أصل غير مؤكد حسب سترونغ. يشير إلى إله، خاصة الإله الأعظم. الاستخدام الكتابي: يكشف الله الحي الذي يعمل في تاريخ الخلاص."
  },
  "G2338": {
    m: "أنثى، مؤنث",
    d: "من الجنس الأنثوي، أنثى.",
    u: "استُخدمت 5 مرات في العهد الجديد. ذكر وأنثى متساويان في المسيح.",
    e: "من θηλάζω (ثيلازو) = أرضع"
  },
  "G2362": {
    m: "عرش",
    d: "مقعد ملكي، عرش؛ سلطة وقوة ملكية.",
    u: "استُخدمت 62 مرة في العهد الجديد. عرش الله والحمل.",
    e: "جذر أساسي"
  },
  "G2381": {
    m: "توما",
    d: "توما، اسم علم. أحد الاثني عشر رسولاً، يُدعى أيضاً ديديموس (التوأم). معروف بطلب أدلة على القيامة.",
    u: "استُخدم 11 مرة في العهد الجديد. الرسول الذي شك ثم آمن.",
    e: "من الآرامية תְּאוֹמָא (تيوما) = توأم"
  },
  "G2398": {
    m: "خاص، مخصوص، شخصي",
    d: "خاص، مخصوص، شخصي، خاص. ما يخص شخصاً بعينه، متميز عن الآخرين.",
    u: "استُخدم 114 مرة في العهد الجديد. مفهوم الملكية الشخصية والتمييز.",
    e: "من جذر غير مؤكد؛ خاص، مخصوص"
  },
  "G2424": {
    m: "يسوع",
    d: "يسوع الناصري، المسيح، المخلّص.",
    u: "استُخدمت 917 مرة في العهد الجديد. الاسم فوق كل اسم.",
    e: "من العبرية יְהוֹשֻׁעַ (يهوشوع) = يهوه يُخلّص"
  },
  "G2453": {
    m: "يهودي، يهوذي",
    d: "ينتمي إلى العرق اليهودي؛ ساكن اليهودية.",
    u: "استُخدمت 195 مرة في العهد الجديد. اليهود، شعب الله المختار.",
    e: "من Ἰούδας (يوداس) = يهوذا"
  },
  "G2491": {
    m: "يوحنا",
    d: "يوحنا، اسم علم. يوحنا المعمدان السابق، يوحنا الرسول المحبوب، كاتب الإنجيل والرسائل.",
    u: "استُخدم 135 مرة في العهد الجديد. اسم شخصيتين عظيمتين في العهد الجديد.",
    e: "من العبرية יוֹחָנָן (يوحانان) = يهوه حنون"
  },
  "G2531": {
    m: "كما، بحسب",
    d: "كما، بالطريقة نفسها؛ بحسب، بقدر ما.",
    u: "استُخدمت 182 مرة في العهد الجديد. أداة مقارنة.",
    e: "من κατά (كاتا) = حسب + ὡς (هوس) = كما"
  },
  "G2537": {
    m: "جديد، حديث",
    d: "جديد في الوقت أو الجودة؛ طازج، حديث، غير مستعمل.",
    u: "استُخدمت 42 مرة في العهد الجديد. خليقة جديدة، وصية جديدة.",
    e: "جذر غير مؤكد"
  },
  "G2570": {
    m: "صالح، حسن",
    d: "صالح في طبيعته، حسن؛ محترم، ممتاز، فاضل.",
    u: "استُخدمت 100 مرة في العهد الجديد. الراعي الصالح، الأعمال الصالحة.",
    e: "جذر أساسي"
  },
  "G2588": {
    m: "قلب",
    d: "القلب الجسدي؛ مركز الحياة الباطنية، النفس، الروح؛ الأفكار والمشاعر.",
    u: "استُخدمت 156 مرة في العهد الجديد. مقر الحياة الروحية.",
    e: "جذر أساسي"
  },
  "G2596": {
    m: "حسب، ضد، عبر",
    d: "حرف جر بعدة معانٍ: حسب، وفقاً لـ؛ ضد؛ عبر.",
    u: "استُخدمت أكثر من 470 مرة في العهد الجديد. حرف جر متكرر جداً.",
    e: "حرف جر أساسي"
  },
  "G2617": {
    m: "أخزى، أهان",
    d: "أخزى، أهان؛ أربك، أذلّ.",
    u: "استُخدمت 13 مرة في العهد الجديد. الله يُربك حكماء العالم.",
    e: "من κατά (كاتا) = ضد + αἰσχύνω (أيسخونو) = خجل"
  },
  "G2744": {
    m: "افتخر، تباهى",
    d: "افتخر، تباهى؛ وجد فخره في شيء.",
    u: "استُخدمت 37 مرة في العهد الجديد. الافتخار في الرب.",
    e: "من καῦχος (كاوخوس) = تباهٍ"
  },
  "G2889": {
    m: "عالم، كون، بشرية",
    d: "نظام العالم، الكون؛ البشرية الساقطة؛ النظام المعارض لله.",
    u: "استُخدمت 186 مرة في العهد الجديد. يمكن أن تشير إلى الخلق أو النظام الخاطئ.",
    e: "من κοσμέω (كوسميو) = زيّن، رتّب"
  },
  "G2919": {
    m: "دان، قرر",
    d: "دان، نطق بحكم؛ قرر، حدد.",
    u: "استُخدمت 114 مرة في العهد الجديد. الله يدين العالم.",
    e: "جذر أساسي"
  },
  "G2920": {
    m: "دينونة، عدالة، إدانة",
    d: "دينونة، عدالة، إدانة، قرار قضائي. دينونة الله، عادلة وكاملة.",
    u: "استُخدمت 47 مرة في العهد الجديد. مفهوم مركزي للعدالة الإلهية.",
    e: "من κρίνω (كرينو) = يدين، يقرر"
  },
  "G2962": {
    m: "رب، سيد، مالك",
    d: "رب، سيد؛ لقب احترام وسلطة إلهية؛ يسوع كرب.",
    u: "استُخدمت 748 مرة في العهد الجديد. 'قال له توما: يا رب، لسنا نعلم أين تذهب' (يوحنا 14:5).",
    e: "من κύριος (كوريوس) = له سلطة"
  },
  "G2992": {
    m: "شعب",
    d: "شعب، أمة؛ خصوصاً شعب الله (إسرائيل أو الكنيسة).",
    u: "استُخدمت 142 مرة في العهد الجديد. الشعب المختار لله.",
    e: "جذر أساسي"
  },
  "G3022": {
    m: "أبيض، مشرق",
    d: "أبيض، ساطع؛ رمز للنقاوة والنصر.",
    u: "استُخدمت 25 مرة في العهد الجديد. الثياب البيضاء للمفديين.",
    e: "من λευκός (ليوكوس) = أبيض، مضيء"
  },
  "G3056": {
    m: "كلمة، كلام، عقل",
    d: "كلمة منطوقة؛ عقل، ذكاء؛ اللوغوس = المسيح.",
    u: "استُخدمت 330 مرة في العهد الجديد. اللوغوس المتجسد.",
    e: "من λέγω (ليغو) = قال"
  },
  "G3101": {
    m: "تلميذ، طالب",
    d: "متعلم، طالب، تلميذ؛ تابع ليسوع.",
    u: "استُخدمت 261 مرة في العهد الجديد. تشير إلى أتباع المسيح.",
    e: "من μανθάνω (مانثانو) = تعلّم"
  },
  "G3141": {
    m: "شهادة، إشهاد",
    d: "شهادة، إشهاد، دليل، برهان. شهادة مُقدمة للحق، خاصة للمسيح.",
    u: "استُخدمت 37 مرة في العهد الجديد. موضوع رئيسي في إنجيل يوحنا.",
    e: "من μάρτυς (مارتوس) = شاهد"
  },
  "G3173": {
    m: "عظيم، كبير",
    d: "كبير في الحجم، الكمية أو الأهمية؛ قوي، عجيب.",
    u: "استُخدمت 243 مرة في العهد الجديد. عظمة الله.",
    e: "جذر أساسي"
  },
  "G3320": {
    m: "جدار فاصل",
    d: "جدار وسط، حاجز فاصل.",
    u: "استُخدمت مرة واحدة في العهد الجديد (أفسس 2:14). الجدار بين اليهود والأمميين.",
    e: "من μέσος (ميسوس) = وسط + τοῖχος (تويخوس) = جدار"
  },
  "G3439": {
    m: "وحيد، المولود الوحيد",
    d: "فريد من نوعه، المولود الوحيد؛ الابن الوحيد.",
    u: "استُخدمت 9 مرات في العهد الجديد. الابن الوحيد لله.",
    e: "من μόνος (مونوس) = وحيد + γίνομαι (جينوماي) = صار"
  },
  "G3474": {
    m: "حماقة، سفاهة",
    d: "حماقة، عبث؛ ما يفتقر إلى الحكمة.",
    u: "استُخدمت 5 مرات في العهد الجديد. حكمة الله تبدو حماقة للعالم.",
    e: "من μωρός (موروس) = أحمق، جاهل"
  },
  "G3475": {
    m: "موسى",
    d: "موسى، المشترع لإسرائيل.",
    u: "استُخدمت 80 مرة في العهد الجديد. شريعة موسى.",
    e: "من العبرية מֹשֶׁה (موشيه) = مُنتشَل (من المياه)"
  },
  "G3530": {
    m: "نيقوديموس",
    d: "نيقوديموس، اسم علم. فريسي وقائد يهودي جاء إلى يسوع ليلاً. اسم يوناني يعني 'انتصار الشعب'.",
    u: "استُخدم 5 مرات في العهد الجديد. شخصية مهمة في إنجيل يوحنا.",
    e: "من اليونانية νίκη (نيكي) = انتصار و δῆμος (ديموس) = شعب"
  },
  "G3551": {
    m: "شريعة، توراة",
    d: "شريعة، توراة، قانون، مبدأ. شريعة موسى، الشريعة الإلهية، وصايا الله.",
    u: "استُخدمت 194 مرة في العهد الجديد. مفهوم مركزي للوحي الإلهي.",
    e: "من νέμω (نيمو) = يوزع، يعطي؛ شريعة معطاة"
  },
  "G3571": {
    m: "ليل",
    d: "ليل، فترة الظلام بين الغروب والشروق. غالباً مجازي للجهل الروحي.",
    u: "استُخدم 61 مرة في العهد الجديد. يُقابل النور في الرمزية اليوحناوية.",
    e: "اسم مؤنث أساسي؛ ليل"
  },
  "G3598": {
    m: "طريق، سبيل",
    d: "طريق، سبيل؛ طريقة عيش، سلوك؛ سبيل الخلاص.",
    u: "استُخدمت 101 مرة في العهد الجديد. يسوع هو الطريق.",
    e: "جذر أساسي"
  },
  "G3609": {
    m: "منزلي، من البيت",
    d: "ينتمي إلى البيت، عضو في العائلة؛ خادم منزلي.",
    u: "استُخدمت 3 مرات في العهد الجديد. تصف أعضاء عائلة الله.",
    e: "من οἶκος (أويكوس) = بيت"
  },
  "G3664": {
    m: "مثل، شبيه",
    d: "مثل، من نفس الطبيعة أو الصفة؛ مساوٍ.",
    u: "استُخدمت 45 مرة في العهد الجديد. الوصية الثانية مثل الأولى.",
    e: "من ὁμός (هوموس) = نفس"
  },
  "G3686": {
    m: "اسم",
    d: "اسم، لقب؛ سمعة؛ سلطة، قوة.",
    u: "استُخدمت 228 مرة في العهد الجديد. اسم يسوع.",
    e: "جذر أساسي"
  },
  "G3708": {
    m: "رأى، نظر",
    d: "رأى بالعينين؛ أدرك، فهم؛ ظهر.",
    u: "استُخدمت 454 مرة في العهد الجديد. رؤية المسيح، رؤية الآب.",
    e: "جذر أساسي"
  },
  "G3735": {
    m: "جبل، تل",
    d: "جبل، طور؛ تل مرتفع.",
    u: "استُخدمت 63 مرة في العهد الجديد. جبل التجلي.",
    e: "ربما من ὁράω (هوراو) = رأى"
  },
  "G3756": {
    m: "لا، لن",
    d: "نفي مطلق، لا، ليس.",
    u: "استُخدمت أكثر من 1600 مرة في العهد الجديد. أداة نفي متكررة جداً.",
    e: "أداة نفي أساسية"
  },
  "G3762": {
    m: "لا أحد، لا شيء، لا",
    d: "لا أحد، لا شيء، لا، ولا واحد. النفي المطلق للوجود أو الكمية.",
    u: "استُخدمت 234 مرة في العهد الجديد. نفي قوي شائع جداً.",
    e: "من οὐδέ (أودي) و εἷς (هيس)؛ ولا حتى واحد"
  },
  "G3778": {
    m: "هذا، هذه، ذلك",
    d: "ضمير إشارة: هذا، هذه، ذلك. يشير إلى شيء قريب أو مذكور سابقاً.",
    u: "استُخدم 1388 مرة في العهد الجديد. ضمير الإشارة الأكثر تكراراً.",
    e: "ضمير إشارة أساسي"
  },
  "G3789": {
    m: "حية",
    d: "حية، زاحف؛ الحية القديمة (الشيطان).",
    u: "استُخدمت 14 مرة في العهد الجديد. الحية النحاسية في البرية.",
    e: "جذر أساسي"
  },
  "G3793": {
    m: "جمع، جمهور",
    d: "جمع من الناس، جمهور؛ الكتلة الشعبية.",
    u: "استُخدمت 175 مرة في العهد الجديد. الجموع التي تبعت يسوع.",
    e: "من ὄχος (أوخوس) = مركبة (التي تحمل)"
  },
  "G3880": {
    m: "يستقبل، يأخذ، يقبل",
    d: "يستقبل، يأخذ، يقبل، يُمسك. استقبال شيء مُقدم أو مُعطى.",
    u: "استُخدم 59 مرة في العهد الجديد. مفهوم محوري لقبول الإنجيل.",
    e: "من παρά (بارا) = بجانب و λαμβάνω (لامبانو) = يأخذ"
  },
  "G3956": {
    m: "كل، جميع",
    d: "كل، كل واحد، جميع؛ المجموع، الكلية.",
    u: "استُخدمت 1244 مرة في العهد الجديد. من بين الكلمات الأكثر تكراراً.",
    e: "جذر أساسي"
  },
  "G3962": {
    m: "أب",
    d: "أب طبيعي أو روحي؛ سلف؛ الله الآب.",
    u: "استُخدمت 413 مرة في العهد الجديد. غالباً للإشارة إلى الله.",
    e: "جذر أساسي مرتبط باللاتينية 'pater'"
  },
  "G4100": {
    m: "آمن، وثق",
    d: "آمن بـ، وثق؛ اتكل على، استند إلى.",
    u: "استُخدمت 241 مرة في العهد الجديد. الإيمان بيسوع للخلاص.",
    e: "من πίστις (بيستيس) = إيمان"
  },
  "G4102": {
    m: "إيمان، ثقة، أمانة",
    d: "القناعة بحقيقة أي شيء، إيمان؛ في العهد الجديد قناعة تتعلق بعلاقة الإنسان بالله والأمور الإلهية.",
    u: "استُخدمت 244 مرة في العهد الجديد. مفهوم مركزي للإيمان المسيحي.",
    e: "من πείθω (بيثو) = أقنع، اقتنع"
  },
  "G4138": {
    m: "امتلاء، وفرة، ما يملأ",
    d: "امتلاء، وفرة، ما يملأ بالكامل. الكمال، الاكتمال الإلهي.",
    u: "استُخدم 17 مرة في العهد الجديد. مفهوم لاهوتي للامتلاء الإلهي في المسيح.",
    e: "من πλήρης (بليريس) = ممتلئ؛ امتلاء"
  },
  "G4139": {
    m: "قريب، جار",
    d: "من هو قريب، الجار؛ القريب بشكل عام.",
    u: "استُخدمت 17 مرة في العهد الجديد. 'أحبب قريبك كنفسك'.",
    e: "ظرف صار اسماً، من πλησίος (بليسيوس) = قريب"
  },
  "G4151": {
    m: "روح، نفَس، ريح",
    d: "نفَس الحياة، المبدأ الحيوي؛ النفس العاقلة؛ الروح القدس.",
    u: "استُخدمت 385 مرة في العهد الجديد. تشير إلى الروح القدس، روح الإنسان أو الأرواح.",
    e: "من πνέω (بنيو) = نفخ، تنفس"
  },
  "G4160": {
    m: "يفعل، يصنع، يُنجز",
    d: "يفعل، يصنع، ينتج، يتصرف، يخلق. فعل عمل عام يغطي جميع أنواع النشاط.",
    u: "استُخدم 568 مرة في العهد الجديد. فعل عمل أساسي، غالباً في أعمال الله.",
    e: "فعل أساسي؛ يفعل، يُنجز"
  },
  "G4166": {
    m: "راعٍ، رعية",
    d: "من يحرس الخراف؛ حارس روحي، راعي كنيسة.",
    u: "استُخدمت 18 مرة في العهد الجديد. يسوع الراعي الصالح.",
    e: "من ποίμνη (بويمني) = قطيع"
  },
  "G4183": {
    m: "كثير، كثيرون، عظيم",
    d: "كثير، كثيرون، عظيم في الكمية أو العدد. جمهور، كمية كبيرة.",
    u: "استُخدم 416 مرة في العهد الجديد. صفة كمية متكررة جداً.",
    e: "جذر غير مؤكد؛ كثير، كثيرون"
  },
  "G4198": {
    m: "يذهب، يمشي، يسافر",
    d: "يذهب، يمشي، يسافر، يتحرك. حركة من مكان لآخر، غالباً بهدف.",
    u: "استُخدم 154 مرة في العهد الجديد. فعل حركة أساسي في الروايات الإنجيلية.",
    e: "فعل أساسي؛ يذهب، يمشي"
  },
  "G4238": {
    m: "يفعل، يمارس، ينجز",
    d: "يفعل، يمارس، ينجز، يتصرف. أداء أعمال، غالباً بفكرة التكرار أو العادة.",
    u: "استُخدم 39 مرة في العهد الجديد. غالباً مرتبط بممارسة الخير أو الشر.",
    e: "شكل مُقوى من πράω (براو)؛ يفعل، يمارس"
  },
  "G4263": {
    m: "خروف، غنم",
    d: "خروف أو غنم؛ مجازياً، تلاميذ المسيح.",
    u: "استُخدمت 39 مرة في العهد الجديد. المؤمنون كخراف الراعي.",
    e: "ربما مرتبط بـ προβαίνω (بروباينو) = تقدّم"
  },
  "G4413": {
    m: "أول، رئيسي",
    d: "أول في الوقت، المكان، الترتيب أو الأهمية.",
    u: "استُخدمت 155 مرة في العهد الجديد. الوصية الأولى، المكان الأول.",
    e: "صيغة تفضيل من πρό (برو) = قبل"
  },
  "G4561": {
    m: "جسد، لحم",
    d: "جسد، لحم؛ الجسم البشري؛ الطبيعة البشرية الساقطة.",
    u: "استُخدمت 147 مرة في العهد الجديد. تباين بين الجسد والروح.",
    e: "جذر أساسي"
  },
  "G4592": {
    m: "آية، معجزة، علامة",
    d: "آية، معجزة، علامة؛ إظهار خارق للطبيعة يكشف القوة الإلهية.",
    u: "استُخدمت 77 مرة في العهد الجديد. 'لأن ليس أحد يقدر أن يعمل هذه الآيات التي أنت تعمل' (يوحنا 3:2).",
    e: "من σημεῖον (سيميون) = علامة، إشارة"
  },
  "G4648": {
    m: "انظر بانتباه، صوّب",
    d: "ثبّت العينين على، اعتبر بانتباه؛ كان في البال، صوّب نحو هدف.",
    u: "استُخدمت 6 مرات في العهد الجديد. دعوة لتثبيت الأنظار على المسيح.",
    e: "مرتبط بـ σκοπός (سكوبوس) = هدف، غاية"
  },
  "G4680": {
    m: "حكيم، عالم",
    d: "حكيم، ذكي، ماهر؛ متعلم، مثقف.",
    u: "استُخدمت 22 مرة في العهد الجديد. الحكمة الحقيقية تأتي من الله.",
    e: "جذر أساسي"
  },
  "G4982": {
    m: "خلّص، أنقذ",
    d: "خلّص من خطر أو هلاك؛ أنقذ من الخطية.",
    u: "استُخدمت 106 مرات في العهد الجديد. يسوع يُخلّص الخطاة.",
    e: "من σῶς (سوس) = سليم وآمن"
  },
  "G5040": {
    m: "طفل صغير",
    d: "طفل صغير، طفل رضيع؛ مصطلح حنون لتلميذ.",
    u: "استُخدمت 8 مرات في العهد الجديد. يوحنا يدعو قراءه 'أطفالاً صغاراً'.",
    e: "تصغير من τέκνον (تيكنون) = طفل"
  },
  "G5087": {
    m: "وضع، أقام، ثبّت",
    d: "وضع، أقام؛ ثبّت، عيّن؛ أودع، وضع.",
    u: "استُخدمت 100 مرة في العهد الجديد. وضع حياته من أجل الخراف.",
    e: "جذر أساسي"
  },
  "G5109": {
    m: "جدار",
    d: "جدار فاصل، حائط.",
    u: "استُخدمت مرة واحدة في العهد الجديد (أعمال 23:3).",
    e: "جذر أساسي"
  },
  "G5207": {
    m: "ابن",
    d: "نسل ذكر؛ تلميذ؛ عضو في مجموعة. ابن الله = يسوع المسيح.",
    u: "استُخدمت 377 مرة في العهد الجديد. غالباً للإشارة إلى يسوع كابن الله.",
    e: "أصل غير مؤكد، ربما مرتبط بـ ὕω (هوو) = أمطر، ولّد"
  },
  "G5281": {
    m: "صبر، احتمال، مثابرة",
    d: "صفة من لا يستسلم للظروف أو الضغوط؛ احتمال صبور، ثبات.",
    u: "استُخدمت 32 مرة في العهد الجديد. فضيلة مسيحية أساسية.",
    e: "من ὑπό (هوبو) = تحت و μένω (مينو) = بقي"
  },
  "G5312": {
    m: "رفع، عظّم",
    d: "رفع إلى أعلى، رفع؛ عظّم، أكرم.",
    u: "استُخدمت 20 مرة في العهد الجديد. ابن الإنسان مرفوع.",
    e: "من ὕψος (هوبسوس) = ارتفاع"
  },
  "G5376": {
    m: "فيلبس",
    d: "فيلبس، اسم علم. أحد الاثني عشر رسولاً. اسم يوناني يعني 'محب الخيول'.",
    u: "استُخدم 36 مرة في العهد الجديد. اسم الرسول والشماس.",
    e: "من اليونانية φίλος (فيلوس) = صديق و ἵππος (هيبوس) = حصان"
  },
  "G5432": {
    m: "حرس، حمى",
    d: "حرس بحراسة عسكرية؛ حمى، حفظ.",
    u: "استُخدمت 4 مرات في العهد الجديد. سلام الله يحرس قلوبنا.",
    e: "من φρουρός (فرووروس) = حارس، حرس"
  },
  "G5443": {
    m: "قبيلة، شعب",
    d: "قبيلة، عشيرة؛ شعب ينحدر من سلف مشترك.",
    u: "استُخدمت 31 مرة في العهد الجديد. القبائل الاثنا عشر لإسرائيل.",
    e: "من φύω (فوو) = أنتج، جعل ينمو"
  },
  "G5457": {
    m: "نور",
    d: "نور جسدي أو روحي؛ الحق الإلهي المعلن.",
    u: "استُخدمت 73 مرة في العهد الجديد. يسوع نور العالم.",
    e: "من φάω (فاو) = أضاء"
  },
  "G5463": {
    m: "فرح، ابتهج",
    d: "فرح، كان سعيداً؛ تحية 'افرح' أو 'سلام'.",
    u: "استُخدمت 74 مرة في العهد الجديد. أمر متكرر بالفرح في المسيح.",
    e: "مرتبط بـ χάρις (خاريس) = نعمة"
  },
  "G5495": {
    m: "يد",
    d: "اليد؛ قوة، سلطة؛ فعل، عمل.",
    u: "استُخدمت 177 مرة في العهد الجديد. يد الله، يدا يسوع.",
    e: "جذر أساسي"
  },
  "G5544": {
    m: "صلاح، إحسان",
    d: "الصلاح في العمل، إحسان عملي؛ صفة من هو مفيد ونافع للآخرين.",
    u: "استُخدمت 10 مرات في العهد الجديد. ثمر الروح حسب غلاطية 5:22.",
    e: "من χρηστός (خريستوس) = صالح، مفيد، محسن"
  },
  "G5547": {
    m: "المسيح، الماشيح، الممسوح",
    d: "الممسوح، المسيح؛ لقب يسوع كالمخلّص الموعود.",
    u: "استُخدمت 529 مرة في العهد الجديد. يسوع هو المسيح.",
    e: "من χρίω (خريو) = مسح"
  },
  "G5590": {
    m: "نفس، حياة",
    d: "نفَس الحياة، النفس الحيوية؛ الحياة نفسها؛ النفس الخالدة.",
    u: "استُخدمت 105 مرات في العهد الجديد. الحياة الروحية والأبدية.",
    e: "من ψύχω (بسوخو) = تنفس، أنعش"
  },
  "H120": {
    m: "إنسان، بشرية، آدم",
    d: "إنسان، كائن بشري؛ البشرية؛ آدم الإنسان الأول.",
    u: "استُخدمت 562 مرة في العهد القديم. الله خلق الإنسان.",
    e: "من אָדֹם (أدوم) = أحمر، أو אֲדָמָה (أداما) = أرض"
  },
  "H160": {
    m: "محبة، عاطفة",
    d: "محبة، عاطفة؛ عمل محبة.",
    u: "استُخدمت 40 مرة في العهد القديم. محبة الله لشعبه.",
    e: "من אָהַב (أهاب) = أحب"
  },
  "H216": {
    m: "نور",
    d: "نور طبيعي أو روحي؛ سعادة، رخاء.",
    u: "استُخدمت 120 مرة في العهد القديم. 'ليكن نور!'",
    e: "من אוֹר (أور) = كان مضيئاً"
  },
  "H430": {
    m: "الله، آلهة",
    d: "الله الأسمى (إلوهيم)؛ يُستخدم أحياناً للقضاة أو الآلهة الوثنية.",
    u: "استُخدمت 2606 مرة في العهد القديم. اسم جمع الجلالة لله.",
    e: "جمع من אֱלוֹהַּ (إلوه) = إله"
  },
  "H559": {
    m: "قال، تكلم",
    d: "قال، تكلم، صرّح؛ أمر، فكّر.",
    u: "استُخدمت 5316 مرة في العهد القديم. فعل الكلام الأكثر تكراراً.",
    e: "جذر أساسي"
  },
  "H776": {
    m: "أرض، بلد",
    d: "أرض، تربة؛ بلد، منطقة؛ العالم الأرضي.",
    u: "استُخدمت 2504 مرة في العهد القديم. الأرض التي خلقها الله.",
    e: "جذر أساسي"
  },
  "H982": {
    m: "توكل، اتكل",
    d: "توكل على، اتكل؛ كان في أمان.",
    u: "استُخدمت 120 مرة في العهد القديم. التوكل على الرب.",
    e: "جذر أساسي"
  },
  "H1004": {
    m: "بيت، منزل",
    d: "بيت، مسكن؛ عائلة، أهل بيت؛ هيكل.",
    u: "استُخدمت 2055 مرة في العهد القديم. بيت الرب.",
    e: "من בָּנָה (بانا) = بنى"
  },
  "H1254": {
    m: "خلق",
    d: "خلق من عدم؛ صوّر، صنع؛ نشاط حصري لله.",
    u: "استُخدمت 54 مرة في العهد القديم. الله خلق السماوات والأرض.",
    e: "جذر أساسي"
  },
  "H1516": {
    m: "وادٍ، خانق",
    d: "وادٍ، شِعب، خانق؛ سهل.",
    u: "استُخدمت 60 مرة في العهد القديم. وادي ظل الموت.",
    e: "جذر أساسي"
  },
  "H1878": {
    m: "سمّن، دسّم",
    d: "جعل سميناً، سمّن؛ ازدهر.",
    u: "استُخدمت 11 مرة في العهد القديم. مسحت بالدهن رأسي.",
    e: "من דֶּשֶׁן (ديشين) = دسم، رماد"
  },
  "H1980": {
    m: "مشى، ذهب",
    d: "مشى، ذهب، جاء؛ عاش، تصرف.",
    u: "استُخدمت 1554 مرة في العهد القديم. فعل حركة متكرر جداً.",
    e: "جذر أساسي"
  },
  "H2617": {
    m: "صلاح، رحمة، أمانة",
    d: "صلاح، رحمة؛ أمانة للعهد؛ محبة وفية.",
    u: "استُخدمت 248 مرة في العهد القديم. صلاح الرب.",
    e: "من חָסַד (حاساد) = كان صالحاً، رحيماً"
  },
  "H2637": {
    m: "احتاج، افتقر",
    d: "افتقر إلى، احتاج؛ نقص، فقد.",
    u: "استُخدمت 23 مرة في العهد القديم. لا أحتاج إلى شيء (مزمور 23:1).",
    e: "جذر أساسي"
  },
  "H2896": {
    m: "حسن، جيد",
    d: "حسن، ممتع، ممتاز؛ محسن، عادل.",
    u: "استُخدمت 559 مرة في العهد القديم. رأى الله أن ذلك حسن.",
    e: "جذر أساسي"
  },
  "H3068": {
    m: "يهوه، الرب",
    d: "الاسم الخاص بالله، الاسم المقدس الرباعي يهوه.",
    u: "استُخدمت 6828 مرة في العهد القديم. الاسم الأكثر قداسة.",
    e: "من הָיָה (هايا) = كان، وُجد"
  },
  "H3117": {
    m: "يوم",
    d: "يوم (عكس الليل)؛ فترة 24 ساعة؛ عصر، زمن.",
    u: "استُخدمت 2301 مرة في العهد القديم. اليوم الذي صنعه الرب.",
    e: "من יוֹם (يوم) = كان حاراً"
  },
  "H3372": {
    m: "خاف، خشي",
    d: "خاف، خشي؛ هاب، احترم الله.",
    u: "استُخدمت 335 مرة في العهد القديم. لا أخاف شراً.",
    e: "جذر أساسي"
  },
  "H3563": {
    m: "كأس، قدح",
    d: "كأس، قدح؛ نصيب، حظ.",
    u: "استُخدمت 31 مرة في العهد القديم. كأسي تفيض.",
    e: "جذر أساسي"
  },
  "H3820": {
    m: "قلب، روح",
    d: "قلب، مقر العواطف؛ روح، ذكاء، إرادة.",
    u: "استُخدمت 598 مرة في العهد القديم. قلب الإنسان.",
    e: "جذر أساسي"
  },
  "H3915": {
    m: "ليل",
    d: "ليل (عكس اليوم)؛ وقت الظلام.",
    u: "استُخدمت 234 مرة في العهد القديم. الله فصل النهار عن الليل.",
    e: "جذر أساسي"
  },
  "H3966": {
    m: "جداً، للغاية",
    d: "جداً، للغاية، كثيراً؛ بقوة، بسرعة.",
    u: "استُخدمت 300 مرة في العهد القديم. كان ذلك حسناً جداً.",
    e: "من מָאַד (مآد) = كان كثيراً"
  },
  "H4325": {
    m: "ماء، مياه",
    d: "ماء، مياه؛ مطر؛ طوفان، بحر.",
    u: "استُخدمت 585 مرة في العهد القديم. مياه الخليقة.",
    e: "مثنى من מַיִם (مايم) = ماء"
  },
  "H4999": {
    m: "مرعى، مسكن",
    d: "مكان رعي، مرج؛ مسكن، منزل.",
    u: "استُخدمت 13 مرة في العهد القديم. في مراعٍ خضراء.",
    e: "من נָאָה (نآه) = كان جميلاً، لائقاً"
  },
  "H5148": {
    m: "قاد، هدى",
    d: "قاد، هدى، وجّه؛ قاد بأمان.",
    u: "استُخدمت 40 مرة في العهد القديم. يهديني (مزمور 23:3).",
    e: "جذر أساسي"
  },
  "H5216": {
    m: "مرعى، أرض مزروعة",
    d: "مرج، مرعى؛ أرض مزروعة، حقل.",
    u: "استُخدمت مرتين في العهد القديم. مراعٍ خضراء.",
    e: "من נִיר (نير) = حرث"
  },
  "H5315": {
    m: "نفس، حياة، شخص",
    d: "نفس، حياة، كائن حي؛ شخص، ذات؛ رغبة، شهية.",
    u: "استُخدمت 753 مرة في العهد القديم. نفسي، حياتي.",
    e: "من נָפַשׁ (نافاش) = تنفس"
  },
  "H5769": {
    m: "أبدية، دائماً",
    d: "زمن غير محدد، أبدية؛ دائماً، إلى الأبد.",
    u: "استُخدمت 439 مرة في العهد القديم. محبة الله الأبدية.",
    e: "من עָלַם (علام) = أخفى، كان مخفياً"
  },
  "H6186": {
    m: "رتّب، هيّأ",
    d: "رتّب بنظام، هيّأ؛ أعدّ مائدة.",
    u: "استُخدمت 75 مرة في العهد القديم. تُعدّ مائدة (مزمور 23:5).",
    e: "جذر أساسي"
  },
  "H6213": {
    m: "صنع، أنجز",
    d: "صنع، فعل، أنجز؛ تصرف، عمل.",
    u: "استُخدمت 2632 مرة في العهد القديم. فعل متكرر جداً.",
    e: "جذر أساسي"
  },
  "H6664": {
    m: "عدل، استقامة",
    d: "عدل، استقامة، إنصاف؛ أمانة.",
    u: "استُخدمت 119 مرة في العهد القديم. سُبُل العدل.",
    e: "من צָדַק (تساداق) = كان عادلاً"
  },
  "H6754": {
    m: "صورة، شبه",
    d: "صورة، شبه؛ شكل، مظهر.",
    u: "استُخدمت 17 مرة في العهد القديم. الإنسان مخلوق على صورة الله.",
    e: "من צָלַל (تسالال) = ظلل، شابه"
  },
  "H6757": {
    m: "ظل الموت، ظلام عميق",
    d: "ظلام عميق، ظلام مميت؛ ظل الموت.",
    u: "استُخدمت 18 مرة في العهد القديم. يرمز إلى الخطر الشديد.",
    e: "من צֵל (تسيل) = ظل + מָוֶת (مافيت) = موت"
  },
  "H6887": {
    m: "في ضيق، خصم",
    d: "كان مضيّقاً، في ضيق؛ خصم، عدو.",
    u: "استُخدمت 58 مرة في العهد القديم. في حضرة مضايقيّ.",
    e: "جذر أساسي"
  },
  "H7121": {
    m: "دعا، صاح، أعلن",
    d: "دعا، صاح؛ سمّى؛ أعلن، استدعى.",
    u: "استُخدمت 736 مرة في العهد القديم. دعا باسم الرب.",
    e: "جذر أساسي"
  },
  "H7200": {
    m: "رأى، نظر",
    d: "رأى بالعينين؛ أدرك، فهم؛ أمّن.",
    u: "استُخدمت 1311 مرة في العهد القديم. رأى الله أن ذلك حسن.",
    e: "جذر أساسي"
  },
  "H7225": {
    m: "بداية، بواكير",
    d: "بداية، ابتداء؛ الأفضل، البواكير.",
    u: "استُخدمت 51 مرة في العهد القديم. 'في البدء خلق الله...'",
    e: "من רֹאשׁ (روش) = رأس، بداية"
  },
  "H7257": {
    m: "استلقى، استراح",
    d: "استلقى، استراح؛ أقام؛ حضن.",
    u: "استُخدمت 30 مرة في العهد القديم. يُريحني (مزمور 23:2).",
    e: "جذر أساسي"
  },
  "H7291": {
    m: "تبع، طارد",
    d: "تبع، طارد؛ اضطهد؛ لاحق عن كثب.",
    u: "استُخدمت 144 مرة في العهد القديم. الخير يتبعني.",
    e: "جذر أساسي"
  },
  "H7307": {
    m: "روح، نفَس، ريح",
    d: "نفَس، ريح؛ روح الله أو الإنسان؛ مزاج عقلي.",
    u: "استُخدمت 378 مرة في العهد القديم. روح الله.",
    e: "من רוּחַ (روح) = نفخ"
  },
  "H7462": {
    m: "رعى، أطعم",
    d: "رعى قطيعاً؛ كان راعياً؛ أطعم، اعتنى.",
    u: "استُخدمت 173 مرة في العهد القديم. الرب راعيّ.",
    e: "جذر أساسي"
  },
  "H7549": {
    m: "جَلَد، فلك",
    d: "جَلَد، قبة سماوية، فلك؛ السماء.",
    u: "استُخدمت 17 مرة في العهد القديم. الجلد في وسط المياه.",
    e: "من רָקַע (راقا) = بسط، طرق"
  },
  "H7626": {
    m: "عصا، سبط",
    d: "عصا، قضيب؛ سبط، فرع عائلي.",
    u: "استُخدمت 190 مرة في العهد القديم. عصاك وعكازك.",
    e: "من שָׁבַט (شابات) = تفرّع"
  },
  "H7725": {
    m: "رجع، عاد، استعاد",
    d: "رجع، عاد؛ استعاد، جدد؛ تاب.",
    u: "استُخدمت 1058 مرة في العهد القديم. يُنعش نفسي.",
    e: "جذر أساسي"
  },
  "H7979": {
    m: "مائدة",
    d: "مائدة للأكل؛ مائدة خبز الوجوه.",
    u: "استُخدمت 71 مرة في العهد القديم. المائدة المعدّة.",
    e: "من שָׁלַח (شالاح) = أرسل، مدّ"
  },
  "H8064": {
    m: "سماوات، سماء",
    d: "سماوات، فلك؛ مسكن الله؛ السماء المرئية.",
    u: "استُخدمت 420 مرة في العهد القديم. السماوات والأرض.",
    e: "مثنى من שָׁמַיִם (شامايم) = أعالٍ"
  },
  "H8414": {
    m: "مشوّه، فارغ، فوضى",
    d: "صحراء، خراب؛ فوضى، فراغ، عدم.",
    u: "استُخدمت 20 مرة في العهد القديم. كانت الأرض مشوّهة وفارغة.",
    e: "من תָּהָה (تاها) = تاه"
  }
};

export default strongTranslationsAR;
